var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCabinet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 262 338.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9caab2;}.cls-2{fill:#ccd6e5;}.cls-3{fill:#b8bcc0;}.cls-4{fill:#343f42;}.cls-5,.cls-7{fill:#d0d6e0;}.cls-19,.cls-24,.cls-6{fill:none;}.cls-6,.cls-7{stroke:#343f42;}.cls-19,.cls-24,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-8{opacity:0.4;}.cls-9{fill:#1f6aad;}.cls-10{fill:#1f69ad;}.cls-11{fill:#257ac1;}.cls-12{fill:#b8bcc1;}.cls-13{fill:#176096;}.Graphic-Style-2,.cls-17{fill:#8ab3ff;}.Graphic-Style-2{opacity:0.5;mix-blend-mode:screen;}.cls-14{fill:#cbd5e4;}.cls-15{fill:#828282;}.cls-16{fill:#b9bdc1;}.cls-18{fill:#588df0;}.cls-19{stroke:#588df0;}.cls-20{fill:#303b3e;}.cls-21{fill:#f44d4d;}.cls-22{fill:#f66562;}.cls-23{fill:#d0d6e2;}.cls-24{stroke:#303b3e;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Interface_02b",
    "data-name": "Interface_02b",
    viewBox: "0 0 33.25 48.54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.65 12.54 6.65 48.54 33.25 39.9 33.25 3.9 6.65 12.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.56 0 33.25 3.9 6.65 12.54 0 8.7 26.56 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 8.7 6.65 12.54 6.65 48.54 0 44.7 0 8.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "23.27 10.14 23.27 25.14 29.93 22.98 29.93 7.98 23.27 10.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "23.27 28.14 23.27 40.14 29.93 37.98 29.93 25.98 23.27 28.14"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 9.97,
    y1: 17.46,
    x2: 19.85,
    y2: 14.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 9.97,
    y1: 20.46,
    x2: 19.85,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 9.97,
    y1: 23.46,
    x2: 19.85,
    y2: 20.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "9.97 29.46 19.95 26.22 19.95 41.22 9.97 44.46 9.97 29.46"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "LabCabinet_01a",
    "data-name": "LabCabinet_01a",
    viewBox: "0 0 262 338.98"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("image", {
    width: 262,
    height: 166,
    transform: "translate(0 172.98)",
    xlinkHref: "data:image/png;base64,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"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "95.89 89.16 65.97 98.88 46.02 165.37 36.04 168.61 59.32 92.04 102.54 77.75 102.54 147 95.89 149.16 95.89 89.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "165.71 288.51 165.71 300.51 159.06 302.65 149.09 296.88 149.09 287.88 165.71 288.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "222.24 270.11 222.24 282.11 215.59 284.25 205.61 278.48 205.61 269.48 222.24 270.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "55.99 225.16 55.99 237.16 49.34 239.31 39.37 233.53 39.37 224.53 55.99 225.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "225.56 218.03 159.06 239.5 36.04 168.61 102.54 147 225.56 218.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "36.04 225.61 159.06 296.63 159.06 239.5 36.04 168.61 36.04 225.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "225.56 218.03 159.06 239.5 159.06 296.63 225.56 275.03 225.56 218.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "212.26 216.32 159.06 233.5 49.34 170.28 102.54 153 212.26 216.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "102.54 147 225.56 218.03 225.56 149.03 102.54 77.75 102.54 147"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "182.34 163.07 59.32 92.04 36.04 168.61 159.06 239.5 182.34 163.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "95.89 88.9 95.89 149.16 46.02 165.37 65.97 98.88 95.89 88.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "102.54 0 225.56 71.03 182.34 85.07 59.32 14.04 102.54 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "225.56 71.03 182.34 85.07 182.34 163.07 225.56 149.03 225.56 71.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "59.32 14.04 59.32 92.04 182.34 163.07 182.34 84.98 59.32 14.04"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Interface_01b"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "172.36 91.31 119.17 60.6 119.17 105.6 172.36 136.31 172.36 91.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "133.46 109.51 133.4 81.79 168.04 101.86 168.04 129.54 133.46 109.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.4,83.52,167,102.43v25.38l-32.58-18.87-.06-25.42m-2-3.47.07,30L169,131.28v-30L132.39,80.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "145.76 93.8 135.79 88.02 135.79 106.02 145.76 111.8 145.76 93.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 162.39,
    y1: 103.43,
    x2: 149.09,
    y2: 95.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 162.39,
    y1: 109.43,
    x2: 149.09,
    y2: 101.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 162.39,
    y1: 115.43,
    x2: 149.09,
    y2: 107.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 162.39,
    y1: 121.43,
    x2: 149.09,
    y2: 113.72
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "130.77 79.11 130.77 109.11 120.8 103.33 120.8 73.33 130.77 79.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M166.22,96.83A2.06,2.06,0,0,0,169,94.7a6.23,6.23,0,0,0-3.06-4.87,3.79,3.79,0,0,0-1.06-.44,2,2,0,0,0-2.74,2.12,6.19,6.19,0,0,0,3.06,4.87A4,4,0,0,0,166.22,96.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M160.72,91.67l3.21-1a1.78,1.78,0,0,1,1.6.25,4.63,4.63,0,0,1,2.23,3.52,1.25,1.25,0,0,1-.53,1.12l-3.58,1.19a1.93,1.93,0,0,1-1.45-.3A4.63,4.63,0,0,1,160,92.89,1.16,1.16,0,0,1,160.72,91.67Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 162.2,
    cy: 94.18,
    rx: 1.68,
    ry: 2.97,
    transform: "translate(-24.05 116.33) rotate(-36.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M156.24,91.05A2.05,2.05,0,0,0,159,88.93a6.21,6.21,0,0,0-3.06-4.88,4,4,0,0,0-1.06-.44,2,2,0,0,0-2.74,2.12,6.25,6.25,0,0,0,3.06,4.88A4.68,4.68,0,0,0,156.24,91.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M150.75,85.89l3.2-1a1.78,1.78,0,0,1,1.6.25,4.63,4.63,0,0,1,2.23,3.52,1.22,1.22,0,0,1-.53,1.12l-3.58,1.19a1.9,1.9,0,0,1-1.44-.3A4.63,4.63,0,0,1,150,87.11,1.14,1.14,0,0,1,150.75,85.89Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 152.23,
    cy: 88.4,
    rx: 1.68,
    ry: 2.97,
    transform: "translate(-22.58 109.18) rotate(-36.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M148.17,86.07a1.81,1.81,0,0,0,2.44-1.9,5.88,5.88,0,0,0-2.85-4.53,3.66,3.66,0,0,0-1-.41,1.82,1.82,0,0,0-2.44,1.9,5.89,5.89,0,0,0,2.86,4.54A3.7,3.7,0,0,0,148.17,86.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 147.48,
    cy: 82.65,
    rx: 1.68,
    ry: 2.97,
    transform: "translate(-20.07 105.17) rotate(-36.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M141.52,82.22a1.81,1.81,0,0,0,2.44-1.9,5.85,5.85,0,0,0-2.85-4.53,3.66,3.66,0,0,0-1-.41,1.82,1.82,0,0,0-2.44,1.9,5.89,5.89,0,0,0,2.86,4.54A3.7,3.7,0,0,0,141.52,82.22Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 140.83,
    cy: 78.8,
    rx: 1.68,
    ry: 2.97,
    transform: "translate(-19.09 100.41) rotate(-36.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M134.87,78.37a1.81,1.81,0,0,0,2.44-1.9,5.88,5.88,0,0,0-2.85-4.54,3.62,3.62,0,0,0-1-.4,1.82,1.82,0,0,0-2.44,1.9A5.87,5.87,0,0,0,133.91,78,3.75,3.75,0,0,0,134.87,78.37Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 134.18,
    cy: 74.95,
    rx: 1.68,
    ry: 2.97,
    transform: "translate(-18.11 95.64) rotate(-36.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M126.32,85.41a1.82,1.82,0,0,0,2.44-1.9A5.86,5.86,0,0,0,125.91,79a3.81,3.81,0,0,0-1-.41,1.82,1.82,0,0,0-2.44,1.9A5.88,5.88,0,0,0,125.35,85,3.76,3.76,0,0,0,126.32,85.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 125.63,
    cy: 81.99,
    rx: 1.68,
    ry: 2.97,
    transform: "translate(-24.06 91.91) rotate(-36.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M126.32,94.41a1.82,1.82,0,0,0,2.44-1.9A5.86,5.86,0,0,0,125.91,88a3.81,3.81,0,0,0-1-.41,1.82,1.82,0,0,0-2.44,1.9A5.88,5.88,0,0,0,125.35,94,3.76,3.76,0,0,0,126.32,94.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 125.63,
    cy: 90.99,
    rx: 1.68,
    ry: 2.97,
    transform: "translate(-29.47 93.72) rotate(-36.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M126.32,103.41a1.82,1.82,0,0,0,2.44-1.9A5.86,5.86,0,0,0,125.91,97a3.81,3.81,0,0,0-1-.41,1.82,1.82,0,0,0-2.44,1.9,5.88,5.88,0,0,0,2.85,4.54A3.76,3.76,0,0,0,126.32,103.41Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 125.63,
    cy: 99.99,
    rx: 1.68,
    ry: 2.97,
    transform: "translate(-34.87 95.52) rotate(-36.92)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 129.14,
    y1: 88.72,
    x2: 122.49,
    y2: 84.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 129.14,
    y1: 97.56,
    x2: 122.49,
    y2: 93.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 129.14,
    y1: 106.68,
    x2: 122.49,
    y2: 102.83
  }), /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_15",
    "data-name": "New Symbol 15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "105.86 58.92 105.86 94.92 79.27 79.56 79.27 43.56 105.86 58.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "89.24 52.05 89.24 67.05 82.59 63.2 82.59 48.2 89.24 52.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "89.24 70.05 89.24 82.05 82.59 78.19 82.59 66.19 89.24 70.05"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 102.54,
    y1: 62.75,
    x2: 92.67,
    y2: 56.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 102.54,
    y1: 65.75,
    x2: 92.67,
    y2: 59.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 102.54,
    y1: 68.75,
    x2: 92.67,
    y2: 62.98
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "102.54 74.75 92.56 68.97 92.56 83.97 102.54 89.75 102.54 74.75"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M149.54,212.36a12.08,12.08,0,0,0,3.14,1.3,9,9,0,0,0,11.24-6.4c1.91-6.21-1.36-14.06-7.28-17.49a12.5,12.5,0,0,0-3.15-1.3,9,9,0,0,0-11.24,6.41C140.35,201.09,143.62,208.93,149.54,212.36ZM144.36,196c1.59-5.18,6.78-7.12,11.6-4.33s7.43,9.25,5.85,14.43-6.78,7.12-11.59,4.32S142.78,201.19,144.36,196Zm-21.56.77a12.88,12.88,0,0,0,3.15,1.3,9,9,0,0,0,11.24-6.41c1.9-6.21-1.37-14.06-7.29-17.49a12.43,12.43,0,0,0-3.14-1.3,9.06,9.06,0,0,0-11.25,6.41C113.61,185.51,116.88,193.36,122.8,196.79Zm-5.17-16.35c1.59-5.18,6.78-7.12,11.59-4.33s7.44,9.25,5.86,14.43-6.78,7.12-11.6,4.33S116.05,185.61,117.63,180.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.15,178.62a12.35,12.35,0,0,0,3.15,1.3,9,9,0,0,0,11.24-6.4c1.9-6.21-1.37-14.06-7.29-17.49a12.35,12.35,0,0,0-3.15-1.3,9,9,0,0,0-11.24,6.4C82,167.35,85.23,175.19,91.15,178.62ZM86,162.27c1.58-5.18,6.77-7.11,11.59-4.32s7.44,9.25,5.85,14.43-6.77,7.11-11.59,4.32S84.39,167.45,86,162.27Zm-20.9.94a12.5,12.5,0,0,0,3.15,1.3,9,9,0,0,0,11.24-6.4c1.9-6.22-1.37-14.06-7.29-17.49a12.43,12.43,0,0,0-3.14-1.3,9,9,0,0,0-11.24,6.4C55.89,151.94,59.16,159.78,65.08,163.21Zm-5.17-16.35c1.59-5.18,6.78-7.11,11.59-4.32s7.44,9.25,5.86,14.43-6.78,7.11-11.6,4.32S58.33,152,59.91,146.86Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "Graphic-Style-2",
    points: "225.56 149.03 225.56 218.03 159.06 239.63 182.34 162.99 225.56 149.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "218.91 160.18 188.99 169.84 169.99 235.97 159.06 239.5 182.34 162.99 225.56 149.03 225.56 218.03 218.91 220.18 218.91 160.18"
  }), /*#__PURE__*/React.createElement("use", {
    width: 33.25,
    height: 48.54,
    transform: "matrix(-1, -0.25, 0, 1, 147.98, 232.01)",
    xlinkHref: "#Interface_02b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Formulering_Stabilisering",
    "data-name": "Formulering & Stabilisering"
  }, /*#__PURE__*/React.createElement("use", {
    width: 262,
    height: 338.98,
    xlinkHref: "#LabCabinet_01a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinet1);
export default __webpack_public_path__ + "static/media/cabinet-1.4f2766b8d9c7c9f503f9ed1b3c8005de.svg";
export { ForwardRef as ReactComponent };